import React from 'react';
import type { ActivityType } from '../../../../../types/auditLogs';

interface ActivityBadgeProps {
  type: ActivityType;
}

const ActivityBadge: React.FC<ActivityBadgeProps> = ({ type }) => {
  const getBadgeConfig = (type: ActivityType) => {
    switch (type) {
      case 'CREATE':
        return { label: 'CREATE', className: 'badge-create' };
      case 'UPDATE':
        return { label: 'UPDATE', className: 'badge-update' };
      case 'LOGIN':
        return { label: 'LOGIN', className: 'badge-login' };
      case 'DELETE':
        return { label: 'DELETE', className: 'badge-delete' };
      default:
        return { label: type, className: 'badge-default' };
    }
  };

  const config = getBadgeConfig(type);
  
  return (
    <span className={`activity-badge ${config.className}`}>
      {config.label}
    </span>
  );
};

export default ActivityBadge;